import axiosInstance from './axiosInstance';

const channelService = {
  list: (params = {}) =>
    axiosInstance.get('/admin/channels', { params }),

  getById: (id) =>
    axiosInstance.get(`/admin/channels/${id}`),

  create: (data) =>
    axiosInstance.post('/admin/channels', data),

  update: (id, data) =>
    axiosInstance.put(`/admin/channels/${id}`, data),

  remove: (id) =>
    axiosInstance.delete(`/admin/channels/${id}`),
};

export default channelService;
